import UserAvatar from "../../common/UserAvatar";
import Username from "../../common/Username";
import ThreadPrefixes from "../../common/ThreadPrefixes";
import React from "react";

const VideoItemHeader = ({video}) => {
	return (
		<>
			<div className="flex w-full items-center mb-2">
				<div className="w-[32px] h-[32px] flex-grow-0 flex-shrink-0 mr-2">
					<UserAvatar user={video.User}/>
				</div>

				<div className="flex-1 min-w-0">
					<Username user={video.User}/>
				</div>
			</div>

			<h3 className="text-white font-semibold mb-4">
				{video.Thread && (
					<div className="inline-block mr-2">
						<ThreadPrefixes thread={video.Thread}/>
					</div>
				)}

				<a href={video.view_url} className="inline-block">
					{video.Thread.title}
				</a>
			</h3>
		</>
	);
}

export default VideoItemHeader;